import { Link } from 'react-router-dom';
import FooterImg1 from '../assets/images/footer/footer-img1.jpg';
import FooterImg2 from '../assets/images/footer/footer-img2.jpg';
import FooterImg3 from '../assets/images/footer/footer-img3.jpg';
import InstaSvg from '../assets/images/svg/insta.svg';
import WhiteLogoSvg from '../assets/images/logo.png';
import facebook from "../assets/images/svg/facebook.svg";
import twitter from '../assets/images/svg/twitter.svg';
import insta from '../assets/images/svg/insta.svg';
import whatsapp from '../assets/images/svg/whatsapp.svg';

const Footer = () => {
    return (
        <>
            {/* <!-- ====================================== Footer Section ===================================== --> */}
            <footer>
                <div className="container">
                    <div className="row footer-row-quick">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 quicklinks-main">
                            <div>
                                <h2 className="working-hours">Nasze usługi</h2>
                                <ul>
                                    <li><a href="/#uslugi">Sprzątanie domów</a></li>
                                    <li><a href="/#uslugi">Sprzątanie kuchni</a></li>
                                    <li><a href="/#uslugi">Mycie okien</a></li>
                                    <li><a href="/#uslugi">Sprzątanie biur</a></li>
                                    <li><a href="/#uslugi">Wymiana pościeli</a></li>
                                </ul>
                            </div>
                            <div>
                                <h2 className="working-hours">Nawigacja</h2>
                                <ul>
                                    <li><a href="/#o-nas">O nas</a></li>
                                    <li><a href="/#uslugi">Usługi</a></li>
                                    <li><a href="/#jak-to-dziala">Jak to działa</a></li>
                                    <li><a href="/OurBlog">Blog</a></li>
                                    <li><a href="/#kontakt">Kontakt</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4">
                            <h2 className="working-hours">Nasz Instagram</h2>
                            <div className="footer-img-group">
                                <a href="https://www.instagram.com" className="img-container">
                                    <img className="footer-imgs" src={FooterImg1} alt="footer-img1" />
                                    <div className="footer-img-overlay">
                                        <img src={InstaSvg} className="brand-instagram" alt="brand-instagram" />
                                    </div>
                                </a>
                                <a href="https://www.instagram.com" className="img-container">
                                    <img className="footer-imgs" src={FooterImg2} alt="footer-img2" />
                                    <div className="footer-img-overlay">
                                        <img src={InstaSvg} className="brand-instagram" alt="brand-instagram" />
                                    </div>
                                </a>
                                <a href="https://www.instagram.com" className="img-container">
                                    <img className="footer-imgs" src={FooterImg3} alt="footer-img3" />
                                    <div className="footer-img-overlay">
                                        <img src={InstaSvg} className="brand-instagram" alt="brand-instagram" />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="media-logo-call-footer fade_up show">
                        <Link to="/">
                            <img src={WhiteLogoSvg} alt="SprzątAsia" style={{ height: "60px", width: "auto", filter: "invert(1) grayscale(1) brightness(2)", mixBlendMode: "screen" }} />
                        </Link>
                        <div className="footer-med-icons-main">
                            <a href="https://www.facebook.com" className="footer-med-icons">
                                <img src={facebook} alt="facebook" />
                            </a>
                            <a href="https://x.com" className="footer-med-icons">
                                <img src={twitter} alt="twiiter" />
                            </a>
                            <a href="https://www.instagram.com" className="footer-med-icons">
                                <img src={insta} alt="insta" />
                            </a>
                            <a href="https://wa.me/+1234567890" className="footer-med-icons">
                                <img src={whatsapp} alt="whatsapp" />
                            </a>
                        </div>
                    </div>
                    <div className="copyrights-main">
                        <p>Copyright © {new Date().getFullYear()} Wszelkie prawa zastrzeżone przez <strong>SprzątAsia</strong>
                        </p>
                        <p>
                            <a href="/documents/polityka-prywatnosci.html">Polityka prywatności</a>
                            {' | '}
                            <a href="/documents/regulamin.html">Regulamin</a>
                        </p>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
